module.exports = __webpack_public_path__ + "static/feature-2-e7a9d984060ceec0f6a08fb7f070f367.png";